module.exports = __webpack_public_path__ + "static/media/new.05df77b6.svg";